module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=3"},{"quantity":0.03,"color":"#91E3AD","label":"3-4"},{"quantity":0.06,"color":"#DEFFB0","label":"4-6"},{"quantity":0.01,"color":"#FFE68C","label":"6-9"},{"quantity":9,"color":"#FF9982","label":"9-12"},{"quantity":12,"color":"#FF4D30","label":">12"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_maize.json
// module id = x4ug
// module chunks = 171